export default "__VITE_ASSET__DPIksV1F__"